/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Ana Ekran',
	myContent: 'İçeriğim',
	teamContent: 'Ekip içeriği',
	folder: 'Klasör',
	files: 'Dosyalar',
	actionMenu: 'Eylem menüsü',
	myFolder: 'Klasörlerim',

	emptyFolderNoContent: 'İçerik yok',

	//EmptyStates
	emptyRecentTitle: 'Yakın zamanda bir içerik görüntülemediniz.',
	emptyStateTitle: 'Veri ekleyerek başlayın',
	emptyStateBody: 'Yukarıdaki Verileri karşıya yükle seçeneğini tıklatın veya verileri karşıya yüklemek için sürükleyin ve bırakın.',
	emptySearchResultTitle: 'Aramanız herhangi bir sonuç döndürmedi.',
	emptyPortalTitle: 'Portal yok',
	emptyPortalBody: 'Şu anda herhangi portalınız yok.',
	emptyWsProjectTitle: 'Watson Studio\'da bir not defteri oluşturarak başlayın.',
	emptyWsProjectBody: 'Cognos Analytics\'e geri döndüğünüzde, not defteriniz burada görünecek.',
	emptyFilteredResultTitle: 'Uygulanan süzgeçler herhangi bir sonuç döndürmedi.',
	emptyDialogViewTitle: 'Öğe yok',
	removeFromRecents: 'En son olanlardan kaldır',

	// Welcome Banner
	welcomeBannerGreeting: 'Merhaba. Cognos Analytics\'e hoş geldiniz.',
	welcomeBannerDescription: 'Cognos Analytics, yapay zeka odaklı self servis analitik olanağını kullanıcılara sağlar. Otomatikleştirilmiş veri hazırlığı, veri keşfi ve görselleştirmelerin nasıl daha güvenli kararlara katkıda bulunabileceğine bakın.',
	welcomeBannerDescription_trialUser: 'Tanıtım videomuza, ürün turumuza ve Çalışmaya Başlarken sekmesine bakarak hemen başlayabilirsiniz.',
	takeTourButtonLabel: 'Ürün turuna katılın',
	watchVideoButtonLabel: 'Videoyu izleyin',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Ana sayfanızdaki hoş geldiniz başlığını kapatmak istediğinizden emin misiniz? Dilediğiniz zaman Profil ve ayarlar > Ayarlar > Genel sekmesinden bunu yeniden etkinleştirebilirsiniz. ',
	hideWelcomeBannerTitle: 'Hoş geldiniz başlığını kapatın',
	ok: 'Tamam',
	cancel: 'İptal',
	//howto video dialog
	modal_how_title: 'Nasıl yapılır videoları',
	modal_overview_title: 'Cognos Analytics\'e genel bakış videosunu izleyin',
	modal_how_play: 'Video oynat',
	modal_how_video_title_overview: 'Genel bakış',
	modal_how_video_title_getStarted: '11.2 sürümünü kullanmaya başlama',
	modal_how_video_title_newUI: 'Yeni Cognos deneyimine hoş geldiniz',
	modal_how_video_title_dataModule: 'Veri modüllerine genel bakış',
	modal_how_video_title_explore: 'Veri keşfine genel bakış',
	modal_how_video_title_dashboard: 'Etkileşimli gösterge panolarına genel bakış',
	modal_how_video_title_reporting: 'Raporlamaya genel bakış',
	modal_how_video_title_mobile: 'Cognos\'un gücü avucunuzun içinde',

	// Toolbar
	search: 'Ara',
	addFolder: 'Klasör ekle',
	addLink: 'Bağlantı ekle',
	filter: 'Süzgeç',
	sort: 'Sırala',
	settings: 'Ayarlar',
	tilesView: 'Döşemeler görünümü',
	listView: 'Liste görünümü',
	columnView: 'Sütun görünümü',

	// Toolbar Actions
	sortBy: 'Sıralama ölçütü',
	sortOrder: 'Sırala',
	name: 'Ad',
	modifiedTime: 'Değiştirildi',
	type: 'Tip',
	ascending: 'Artan',
	descending: 'Azalan',

	filterType: 'Tip',
	filterModificationTime: 'Değiştirildi',
	all: 'Tümü',
	today: 'Bugün',
	yesterday: 'Dün',
	pastWeek: 'Geçen hafta',
	pastMonth: 'Geçen ay',
	resetFilters: 'Süzgeçleri sıfırla',

	filterSearchPlaceHolder: 'Anahtar sözcüklere göre süz',

	resetFilterTag: 'Süzgeçleri sıfırlamak için X\'i tıklatın.',
	filterTagToolTip: 'Uygulanan süzgeçler: %{appliedFilters}.',

	folderName: 'Klasör adı',
	addAFolder: 'Klasör ekle',
	add: 'Ekle',
	error: 'Hata',
	newFolderDefaultName: 'Yeni Klasör',
	toastCreateNewFolder: '%{nameOfFolder} klasörü %{tabName} içinde oluşturuldu.',
	folderAdded: 'Klasör eklendi',
	refresh: 'Yenile',
	openFolder: 'Klasörü aç',

	addAUrl: 'URL ekle',
	linkName: 'URL adı',
	linkNamePlaceholder: 'URL adı ekle',
	linkDescription: 'Açıklama (isteğe bağlı)',
	linkDescriptionPlaceholder: 'Tanım ekle',
	linkUri: 'URL',
	linkUriPlaceholder: 'Kabul edilebilir etki alanına sahip bir URL ekle',
	acceptableDomains: 'Kabul edilebilir etki alanları',
	viewAcceptableDomains: 'Kabul edilebilir etki alanlarını görüntüle',
	mandatoryField: 'Zorunlu alan',
	linkAdded: 'URL eklendi',
	toastCreateNewLink: '%{nameOfLink}, %{tabName} konumuna eklendi.',
	noEntries: 'Kabul edilebilir etki alanları listesinde bir girdi yok. Yöneticinizle irtibata geçin.',

	compact: 'Küçük',
	short: 'Kısa',
	default: 'Varsayılan',
	rowSize: 'Satır boyutu',

	// GroupyByTypes
	folders: 'Klasörler',
	reports: 'Raporlar',
	dashboards: 'Panolar',
	data: 'Veri',
	packages: 'Paketler',
	explorations: 'Keşifler',
	stories: 'Hikayeler',
	notebooks: 'Not Defterleri',
	others: 'Daha Fazla',

	// Error Messages
	itemsOverLimit: 'Belirtilen ad "%{itemName}" üst sınırı (20) aştı. Devam etmek için lütfen farklı bir ad belirleyin.',
	errorMessageLengthFolderName: 'Lütfen 255 karakteri geçmeyen bir klasör adı girin.',
	errorMessageLengthLinkName: 'Lütfen 255 karakteri aşmayan bir bağlantı adı girin.',
	toastLaunchPerspectiveError: '%{objectType} açılamıyor.',
	errorNoAccessTitle: 'Bu içeriğe erişiminiz yok gibi görünüyor',
	errorNoAccessBody: 'Sistem yöneticinizle iletişim kurun ya da şu bağlantıya bakın:',
	errorEnableExternalContent: 'Dış içerik etkinleştirme',

	//TableHeader
	lastModified: 'Son Değiştirme Zamanı',
	location: 'Yer',
	tenant: 'Kiracı',

	// GetStartedTab
	getStartedLabel: 'IBM Cognos Analytics\'te çalışmaya devam edin',
	learningHowToLabel: 'Eğitim kaynakları',
	learningHowToDescription: 'Toplulukla bağlantı kurarak, belgeleri okuyarak ve videoları izleyerek daha çok bilgi sahibi olun ve yardım alın.',
	learningHowToActionLabel: 'Eğitim bölmesini başlat',
	howToVideosLabel: 'Nasıl yapılır videoları',
	howToVideosDescription: 'IBM Cognos Analytics\'in nasıl kullanılacağı hakkında bilgi edinin ve verilerinize ilişkin içgörüler edinmeye başlayın.',
	howToVideosActionLabel: 'Videoları izleyin',
	acceleratorCatalogLabel: 'Hızlandırıcılar Kataloğu',
	acceleratorCatalogDescription: 'Sektördeki kullanımların, en iyi uygulama kılavuzlarının, özel görselleştirmelerin de dahil olduğu büyüyen kataloğa göz atın.',
	acceleratorCatalogActionLabel: 'Kataloğa göz atın',
	sampleSectionTitle: 'Örnekler',
	sampleSectionDescription: 'Cognos Analytics\'in sunduğu tüm olanakları gösteren örneklerle siz de deneyin.',
	// Samples Section
	createDashboardSampleTitle: 'İlk gösterge panonuzu oluşturma',
	createDashboardSampleDescription: 'Cognos Dashboards ile analitik yolculuğunuza başlayın.',
	covid19SampleTitle: 'COVID Gösterge Panosu',
	covid19SampleDescription: 'COVID-19 ile ilgili verileri ve özel uzantıları analiz eden bu Cognos Dashboard ile nelerin mümkün olduğunu keşfedin.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Sankey Chart gibi özel görselleştirmelerle görselleştirme kitaplığınızı genişletin.',
	viewAllSamplesActionLabel: 'Tüm örnekleri görüntüle',
	byFeatureTitle: 'Özelliğe göre',
	byFeatureDescription: 'Temel işlevsellik, özel denetimler, uzantılar, not defterleri ve göreli tarihler gibi özelliğe göre örneklere göz atın.',
	byIndustryTitle: 'Sektöre göre',
	byIndustryDescription: 'Otomotiv, bankacılık gibi sektöre göre örneklere göz atın.',
	// SamplesTab
	sampleTabTitle: 'Önceden oluşturulmuş örneklerimizden ilham alın',
	sampleTabLabel: 'IBM, iş ortakları ve müşterilerden daha fazla örnek görüntülemek için Hızlandırıcılar Kataloğu\'nu ziyaret edin',

	// quickLaunch
	quickLaunchLabel: 'Hızlı başlat',
	expand: 'Genişlet',
	collapse: 'Daralt',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Ne oluşturmak istediğinizi seçerek başlayın.',

	// contentPageView
	contentPageTitleLabel: 'İçerik',
	uploadFile: 'Verileri karşıya yükle',
	new: 'Yeni',
	create: 'Oluştur',
	more: 'Daha fazla',

	// open dialog
	selectDataSourcesToAdd: 'Eklenecek veri kaynağını/kaynaklarını seçin.',
	openDialogDefaultTitle: 'Aç',

	// save dialog
	save: 'Kaydet',
	saveAs: 'Farklı kaydet',
	saving: 'Kaydediliyor...',
	selectedDestination: 'Seçilen hedef: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' farklı bir tipte zaten var. Lütfen farklı bir ad seçin.',
	confirmOverwriteTitle: 'Var olan verilerin değiştirilmesini onayla',
	confirmOverwriteMsg: '\'%{nameOfFile}\' adlı dosya zaten var. Bu dosyanın verilerini, seçilen dosyada bulunan verilerle değiştirmek istiyor musunuz?',

	// copy move dialog
	copy: 'Kopyala',
	move: 'Taşı',
	copyOrMove: 'Kopyala veya taşı: ',
	copyOnly: 'Kopyala ',
	createShortcut: 'Kısayol oluştur',
	createShortcutDialogTitle: 'Kısayol oluştur: ',

	// External asset types
	wsProject: 'Watson Studio projesi',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Paket',
	dataModule: 'Veri modülü',
	exploration: 'Keşif',
	mode: 'Kip',
	live: 'Canlı',
	snapshot: 'Anlık Görüntü',
	noSnapshotsFound: 'Bir Anlık Görüntü bulunamadı',
	uploadedFile: 'Karşıya yüklenen dosya',
	fileUpload: 'Verileri karşıya yükle',
	dataSetEx: 'Veri kümesi',
	externalRepository: 'Dış havuz',
	queryMode: 'Sorgu kipi',
	queryModeCompatible: 'Uyumlu',
	queryModeDynamic: 'Dinamik',
	report: 'Rapor',
	activeReport: 'Etkin Rapor',
	query: 'Sorgu',
	analysis: 'Çözümleme',
	dashboard: 'Gösterge Panosu',
	dashboardTemplate: 'Gösterge panosu şablonu',
	jupyterNotebook: 'Not Defteri',
	wsNotebook: 'Watson Studio not defteri',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Hikaye',
	workspace: 'Çalışma Alanı',
	pagelet: 'Sayfa',
	content: 'İçerik',
	directory: 'Ad alanları',
	dataSet: 'Veri kümesi',
	powerPlayCube: 'PowerPlay Kübü',
	powerPlayReport: 'PowerPlay Raporu',
	powerPlay8Report: 'PowerPlay Raporu',
	powerPlay8ReportView: 'PowerPlay Raporu Görünümü',
	reportTemplate: 'Rapor şablonu',
	packageConfigurations: 'Paket Yapılandırması',
	agent: 'Aracı',
	agentDefinition: 'Aracı Tanımı',
	agentDefinitionView: 'Aracı Görünümü',
	dataMovementTask: 'Veri Taşıma Görevi',
	dataMovementTaskAlias: 'Veri Taşıma Görevi Diğer Adı',
	document: 'Belge',
	DocumentRetention: 'Belge özellikleri',
	jobDefinition: 'İş Tanımlaması',
	job: 'İş',
	metricsDataSourceETLTask: 'Metrik Veri Kaynağı ETL Görevi',
	metricsExportTask: 'Metrik Dışa Aktarma Görevi',
	metricsFileImportTask: 'Metrik Dosya İçe Aktarma Görevi',
	metricsMaintenanceTask: 'Metrik Bakımı Görevi',
	planningTask: 'Planlama Görevi',
	shortcut: 'Kısayol',
	URL: 'URL',
	launchable: 'Başlatılabilir',
	dataSetFolder: 'Veri Kümesi Klasörü',
	ViewAccessibleLabel: '%{label} görüntüle',
	overrideReportOptions: 'Varsayılan rapor seçeneklerini geçersiz kıl',
	formats: 'Biçimler',
	saveReport: 'Raporu kaydet',
	promptForValues: 'Bana sor',
	reportView: 'Rapor Görünümü',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel Verileri',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Ayrıntılar',
	open: 'Aç',
	created: 'Oluşturma',
	modified: 'Değiştirme',
	owner: 'Sahip',
	dataSource: 'Veri Kaynağı',
	share: 'Paylaş',
	addToFavorites: 'Sık kullanılanlara ekle',
	properties: 'Özellikler',
	detailsEmptyStateBody: 'Ayrıntılarını görüntülemek için bir öğe seçin',
	editNameAndDescription: 'Ad ve açıklamayı düzenle',
	none: 'Yok',

	//rename dialog
	nameInvalid: 'Ad geçersiz',
	namePlaceholder: 'Ad girin',
	description: 'Tanım',
	descriptionInvalid: 'Açıklama 350 karakteri aşamaz. ',
	descriptionPlaceholder: 'Bir Açıklama girin',
	errorMessageApostropheError: 'Lütfen hem \' hem de " karakteri içermeyen bir dosya adı girin',
	renameCollisionError: '%{name} zaten var. Farklı bir ad deneyin.',
	unknownRenameError: 'Öğe yeniden adlandırma başarısız oldu. Daha fazla yardım için yöneticinizle iletişim kurun.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Belirtilen klasör açılamıyor.',

	//Upload
	uploadToFolder: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction} konumuna yükle",
	uploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> konumuna yükle ve %{launchAction} başlat",
	quickUpload: "Hızlı karşıya yükleme",
	quickUploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> konumuna yüklemek için dosyaları sürükleyin ve bırakın ve aşağıdaki alanların birinde açın.",
	unsupportedFilesSingle: "%{files} Hızlı başlatma için geçersiz olduğundan karşıya yüklenemedi.",
	unsupportedFilesMultiple: "Hızlı başlatma seçeneğini kullanmak için seçtiğiniz tüm dosyaların geçerli olması gerektiğinden dosyalar karşıya yüklenmedi.",
	unsupportedFilesSingleInvalid: "%{files} geçersiz.",
	unsupportedFilesMultipleInvalid: "%{files} geçersiz.",
	supportedFileTypes: "Yalnızca aşağıdaki dosya tiplerine izin veriliyor: %{extensions}.",
	uploadDragAndDrop: "Sürükle ve Bırak",
	uploadDragAndDropMessage: "Dosyayı buraya sürükleyip bırakarak şu konuma karşıya yükleyin: <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Arama ölçütü \'%{searchTerm}\' kaydedildi.',
	searchWasntSaved: 'Arama ölçütü \'%{searchTerm}\' kaydedilmedi.',
	searchSuggestions: 'Öneriler',
	savedSearch: 'Kayıtlı aramalar',
	searchWasDeleted: 'Arama ölçütü \'%{searchTerm}\' silindi.',
	searchWasntDeleted: 'Arama ölçütü \'%{searchTerm}\' silinmedi.',
	savedBarTitle: 'Cognos Analytics\'te Ara',
	searchContentPageTitle: 'Ara',
	searchContentPageTitleLabel: '\'%{searchTerm}\' için sonuçlar gösteriliyor',
	showingSearchRsult: '%{resultCount} öğe gösteriliyor',
	saveSearch: 'Aramayı kaydet',
	saveTenSearches: '10 arama kaydedebilirsiniz.',
	deleteASearch: 'Birini kaydetmek için diğerini silin.',
	close: 'Kapat',

	//recent view
	recents: 'En Son',
	noAccessRecent: 'Erişim yok',
	noAccessRecentMsg: 'Bu varlığa erişiminiz yok. Devre dışı bırakılmış ya da silinmiş olabilir veya izinleriniz azaltılmış olabilir. Varlığın beklenen kaynak konumundaki durumunu doğrulayın. Tamam düğmesini tıklatarak, varlığı en son öğelerinizden kaldırabilirsiniz.',
	noAccessMsg: 'Bu varlığa erişiminiz yok. Devre dışı bırakılmış ya da silinmiş olabilir veya izinleriniz azaltılmış olabilir.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} öğe seçildi',
	itemSelected: '%{nameOfSelection} öğesi seçildi'

});